import React, { useState } from "react";
import { Container } from "reactstrap";

import { contactSales } from "@/utils/content";
import ContactForm from "../generic/contact-form";
import classes from "@/styles/contact/contact-sales-main.module.css";
import useAlertBar from "@/hooks/useAlertBar";
import { sendSalesEmail } from "@/services/connectWithUsServices";
import { useIsMobile } from "@/hooks/useIsMobile";

const ContactSalesMain = () => {
  const content = contactSales.en;
  const { openAlertBar } = useAlertBar();
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    setLoading(true);

    const requestData = { ...data };
    requestData.carriers = requestData.carriers
      .filter((item: any) => typeof item === "string")
      .join(", ");

    try {
      let res = await sendSalesEmail(requestData);

      if (res.data.status) {
        setLoading(false);
        openAlertBar(res.data.message, true);
      } else {
        setLoading(false);
        openAlertBar("Error occurred while sending your request", false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      openAlertBar("Error occurred while sending your request", false);
    }
  };

  return (
    <main className={classes.container}>
      <Container>
        <section className="my-5">
          <div className="text-center">
            <h2 className="fw-bold">{content.title}</h2>
            <p>
              {content.subTitle1}
              <br />
              {content.subTitle2}
            </p>
          </div>
        </section>
        <section className="my-5">
          <div className={`mx-auto ${isMobile ? "" : "w-75"}`}>
            <ContactForm submitHandler={handleSubmit} loading={loading} />
          </div>
        </section>
      </Container>
    </main>
  );
};

export default ContactSalesMain;
